<div class="picker-backdrop" (click)="cancel.emit()">
  <div class="picker-sheet" (click)="$event.stopPropagation()">
    <div class="picker-header">
      <h3>Choose Avatar</h3>
      <button
        class="picker-close"
        type="button"
        (click)="cancel.emit()"
        aria-label="Close"
      >
        ✕
      </button>
    </div>

    <div class="picker-grid">
      @for (av of avatars; track av.seed) {
        <button
          class="avatar-cell"
          type="button"
          [class.selected]="isSelected(av.url)"
          (click)="pick(av.url)"
          [attr.aria-label]="av.seed"
        >
          <img
            [src]="av.url"
            [alt]="av.seed"
            loading="lazy"
            draggable="false"
          />
        </button>
      }
    </div>

    <div class="picker-footer">
      <button class="picker-cancel-btn" type="button" (click)="cancel.emit()">
        Cancel
      </button>
      <button
        class="picker-confirm-btn"
        type="button"
        [disabled]="!selected() && !currentUrl()"
        (click)="confirm()"
      >
        Use This Avatar
      </button>
    </div>
  </div>
</div>
